import {app} from '../../app';
import { Controller } from './show-clone-code.controller';

app.component('showCloneCode', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./show-clone-code.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/show-clone-code/show-clone-code.component.js